import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const CarouselIndicators = ({ className, activeStep, steps, onStepClick })=>{
    const handleClick = useCallback((index)=>()=>onStepClick(index), [
        onStepClick
    ]);
    return jsx("div", {
        className: classNames('cb-carousel-indicators', className),
        "data-testid": "carousel-indicators",
        children: Array.from(Array(steps)).map((_, index)=>jsx("div", {
                children: jsx(Icon, {
                    className: classNames('indicator', {
                        'active-indicator': activeStep === index
                    }),
                    name: "EllipseSolid",
                    onClick: handleClick(index),
                    size: 15
                })
            }, index))
    });
};
CarouselIndicators.displayName = 'Carousel.Indicators';

export { CarouselIndicators };
//# sourceMappingURL=Carousel.Indicators.es.js.map
